import { displayFlex, media } from '@onhandtech/onhand-toolkit'
import styled from 'styled-components'

export const AdminLayout = styled.div`
  ${displayFlex({ flexDirection: 'column' })}
`

export const MainContent = styled.main`
  width: 100%;
  margin-top: 1rem;
  padding: 0 1.3rem;

  @media ${media.laptop} {
    margin-top: 2rem;
    padding: 0 7rem;
  }
`
